export const appConstants = {
  GET_BUDGET_SUCCESS: "GET_BUDGET_SUCCESS",
  REQUESTING_BUDGET: "REQUESTING_BUDGET",
  GET_BUDGET_FAILED: "GET_BUDGET_FAILED",
  REQUESTING_MONTLY_BUDGET: "REQUESTING_MONTLY_BUDGET",
  GET_MONTHLY_EXPENSE: "GET_MONTHLY_EXPENSE",
  GET_MONTHLY_INCOME: "GET_MONTHLY_INCOME",
  GET_MONTHLY_BUDGET_FAILED: "GET_MONTHLY_BUDGET_FAILED",
  SET_START_DATE: "SET_START_DATE",
  SET_END_DATE: "SET_END_DATE",
  UPDATE_LOGIN_STATUS: "UPDATE_LOGIN_STATUS",
  LOGIN_ERROR:"LOGIN_ERROR",
  REQUESTING_LOGIN: "REQUESTING_LOGIN",
  UPDATE_USER_STATUS: "UPDATE_USER_STATUS",
  UPDATE_CURRENCY: "UPDATE_CURRENCY",
  GET_ARCHIVE_BUDGET_SUCCESS: "GET_ARCHIVE_BUDGET_SUCCESS",
  INVALID_REQUEST: "INVALID_REQUEST",
  REQUESTING:"REQUESTING",
  UPDATE_TAG_LIST:"UPDATE_TAG_LIST",
  ERROR_OCCURED:"ERROR_OCCURED",
  UPDATE_ACCOUNT_LIST: "UPDATE_ACCOUNT_LIST",
  UPDATE_USER_SETTINGS: "UPDATE_USER_SETTINGS",
};

export const icons = [
  "beach-ball.png",
  "couple.png",
  "discount.png",
  "drink.png",
  "home.png",
  "airplane.png",
  "around-the-world.png",
  "books.png",
  "car.png",
  "credit-card.png",
  "cutlery.png",
  "dog.png",
  "dress.png",
  "dumbell.png",
  "fruit.png",
  "furnitures.png",
  "gadgets.png",
  "grocery.png",
  "gas-station.png",
  "gift-box.png",
  "guitar.png",
  "home-appliance.png",
  "heart.png",
  "hearts.png",
  "location.png",
  "piggy-bank.png",
  "refrigerator.png",
  "settings.png",
  "shopping-bag.png",
  "shopping-cart.png",
  "smartphone.png",
  "sport.png",
  "stethoscope.png",
  "sun-bath.png",
  "salary.png",
  "shop.png",
  "tshirt.png",
  "train.png",
  "toddler.png",
  "video.png",
  "wallet.png",
  "web-domain.png",
];


export const months = [
  { name: "January", id: 1, days: 31 },
  { name: "February", id: 2, days: 28 },
  { name: "March", id: 3, days: 31 },
  { name: "April", id: 4, days: 30 },
  { name: "May", id: 5, days: 31 },
  { name: "June", id: 6, days: 30 },
  { name: "July", id: 7, days: 31 },
  { name: "August", id: 8, days: 31 },
  { name: "September", id: 9, days: 30 },
  { name: "October", id: 10, days: 31 },
  { name: "November", id: 11, days: 30 },
  { name: "December", id: 12, days: 31 },
];

export const items = [
  {
    title: "Step 1: Add all your expenses to create budget",
    img: "https://i.imgur.com/EMcyIBn.png",
    text: "Managing a budget effectively is crucial for maintaining financial stability and achieving long-term financial goals. By using MoneyTrek you can make the budget management easier.",
    icon: "paint-brush",
  },
  {
    title: "Step 2: See Budget in advance",
    text: "Add your one time or recurring(monthly, yearly, half-yearly, quartely) payments once in the app and get the monthly buget created automatically for each month.",
    icon: "quote-left",
    img: "https://i.imgur.com/PldPiNS.png",
  },
  {
    title: "Step 3: Easily manage your bills/payments",
    text: "Don't need to store any payment date separately, All type of expenses/income gets tracked easily using the app.",
    img: "https://i.imgur.com/ih8gwVB.png",
    icon: "lightbulb",
  },
];

export const occurances = [
  {
    value: 1,
    label: "One-Time",
  },
  {
    value: 2,
    label: "Monthly",
  },
  {
    value: 3,
    label: "Quarterly",
  },
  {
    value: 4,
    label: "Half-Yearly",
  },
  {
    value: 5,
    label: "Yearly",
  },
];

export const sortingType = [
  {
    value: 1,
    label: "Date Wise Ascending",
  },
  {
    value: 2,
    label: "Date Wise Descending",
  },
  {
    value: 3,
    label: "Paid Items First",
  },
  {
    value: 4,
    label: "Pending Items First",
  }
];

